namespace Matrix.Visualizer {
    export interface GraphNodeForm {
        GraphInstanceId: Serenity.IntegerEditor;
        NodeKey: Serenity.StringEditor;
        Caption: Serenity.StringEditor;
        Tooltip: Serenity.StringEditor;
        ShapeName: Serenity.StringEditor;
        BorderColour: Serenity.StringEditor;
        BackgroundColour: Serenity.StringEditor;
        TextColour: Serenity.StringEditor;
        TextFont: Serenity.StringEditor;
        TextAlign: Serenity.StringEditor;
        TextUnderline: Serenity.BooleanEditor;
        ContextMenuTemplate: Serenity.StringEditor;
        RowId: Serenity.IntegerEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class GraphNodeForm extends Serenity.PrefixedContext {
        static formKey = 'Visualizer.GraphNode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GraphNodeForm.init)  {
                GraphNodeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.BooleanEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(GraphNodeForm, [
                    'GraphInstanceId', w0,
                    'NodeKey', w1,
                    'Caption', w1,
                    'Tooltip', w1,
                    'ShapeName', w1,
                    'BorderColour', w1,
                    'BackgroundColour', w1,
                    'TextColour', w1,
                    'TextFont', w1,
                    'TextAlign', w1,
                    'TextUnderline', w2,
                    'ContextMenuTemplate', w1,
                    'RowId', w0,
                    'Version', w3,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4
                ]);
            }
        }
    }
}
